import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

function urlKey(location) {
  return `${location.pathname}${location.search}${location.hash}`;
}

export default function WidgetTrackerRouteViews() {
  const location = useLocation();
  const lastSent = useRef(urlKey(location));

  useEffect(() => {
    const key = urlKey(location);
    // The index.html snippet already sent the initial pageview.
    if (key === lastSent.current) return;
    if (typeof window.widgetTracker === "function") {
      window.widgetTracker("send", "pageview");
      lastSent.current = key;
    }
  }, [location]);

  return null;
}
